import { render } from "./TextCellDataTableComponent.vue?vue&type=template&id=1fb94b70&scoped=true"
import script from "./TextCellDataTableComponent.vue?vue&type=script&lang=js"
export * from "./TextCellDataTableComponent.vue?vue&type=script&lang=js"

import "./TextCellDataTableComponent.vue?vue&type=style&index=0&id=1fb94b70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb94b70"]])

export default __exports__